import React from 'react'
import { ActionButton } from 'uiComponents/buttons'
import { DotNavigation } from 'uiComponents/navigation/dotNavigation'
import { useTranslation } from 'translations'
import { MenuStepType } from './schema'
import { apfSteps } from './steps'

interface StepFooterProps {
    currentStep: MenuStepType
    onStepChange: (step: MenuStepType) => void
    onSave: () => void
}

function StepFooter({ currentStep, onStepChange, onSave }: StepFooterProps) {
    const { t } = useTranslation()
    const index = apfSteps.findIndex((step) => step.name === currentStep)
    const isLast = index === apfSteps.length - 1

    return (
        <div className="apf-step-footer">
            <div className="apf-step-footer__side">
                {index > 0 && (
                    <ActionButton
                        size="large"
                        secondary
                        type="button"
                        onClick={() => onStepChange(apfSteps[index - 1].name)}
                    >
                        {t('common.back')}
                    </ActionButton>
                )}
            </div>
            <DotNavigation
                activeIndex={index}
                amount={apfSteps.length}
                onClick={(i) => onStepChange(apfSteps[i].name)}
                disabled={false}
            />
            <div className="apf-step-footer__side apf-step-footer__side--end">
                <ActionButton
                    size="large"
                    kind={isLast ? 'default' : 'action'}
                    type="button"
                    onClick={isLast ? onSave : () => onStepChange(apfSteps[index + 1].name)}
                >
                    {isLast ? t('studioAPF.stepFooter.publish') : t('common.next')}
                </ActionButton>
            </div>
        </div>
    )
}

export default StepFooter
